(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chel-brands-department"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.chel-brands').forEach((section) => {
    const input = section.querySelector('[data-brand-search]');
    const items = [...section.querySelectorAll('[data-brand-item], [data-brand-card]')];
    const groups = [...section.querySelectorAll('[data-brand-group]')];
    const empty = section.querySelector('[data-brand-empty]');
    const count = section.querySelector('[data-brand-count]');
    if (!input) return;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const match = item.dataset.brandName.includes(query);
        item.hidden = !match;
        if (match && item.hasAttribute('data-brand-item')) visible += 1;
      });
      groups.forEach((group) => { group.hidden = !group.querySelector('[data-brand-item]:not([hidden])'); });
      empty.hidden = visible !== 0;
      if (count) count.textContent = `${visible} brands available`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chel-home-department-store"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-chel-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-chel-slide]')];
    const dots = [...slider.querySelectorAll('[data-chel-dot]')];
    if (slides.length < 2 || slider.dataset.ready === 'true') return;
    slider.dataset.ready = 'true';
    let current = 0;
    let timer;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const active = position === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, position) => {
        const active = position === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };
    const start = () => {
      clearInterval(timer);
      if (slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => show(current + 1), Number(slider.dataset.speed) || 6000);
      }
    };
    slider.querySelector('[data-chel-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
    slider.querySelector('[data-chel-next]')?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.chelDot)); start(); }));
    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', () => clearInterval(timer));
    slider.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chel-home-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-chel-slider]').forEach((slider)=>{const slides=[...slider.querySelectorAll('[data-chel-slide]')],dots=[...slider.querySelectorAll('[data-chel-dot]')];if(slides.length<2||slider.dataset.ready==='true')return;slider.dataset.ready='true';let current=0,timer;const show=(index)=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active))});dots.forEach((dot,i)=>{const active=i===current;dot.classList.toggle('is-active',active);dot.setAttribute('aria-selected',String(active))})};const start=()=>{clearInterval(timer);if(slider.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>show(current+1),Number(slider.dataset.speed)||6000)};slider.querySelector('[data-chel-prev]')?.addEventListener('click',()=>{show(current-1);start()});slider.querySelector('[data-chel-next]')?.addEventListener('click',()=>{show(current+1);start()});dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.chelDot));start()}));slider.addEventListener('mouseenter',()=>clearInterval(timer));slider.addEventListener('mouseleave',start);slider.addEventListener('focusin',()=>clearInterval(timer));slider.addEventListener('focusout',start);start()});

  } catch(e) { console.error(e); }
})();
})();
